import styled from 'styled-components'

const H1 = styled.h1`
  font-family: 'Montserrat', sans-serif;
  text-transform: capitalize;
  margin: 0;
  font-size: 2em;
`
export default H1
